import { Component, inject } from '@angular/core';
import { UnsubscribeService } from "../../../services/unsubscribe.service";
import { ActivatedRoute } from "@angular/router";
import { EvLogoLoaderComponent } from "src/app/shared-components/ev-logo-loader/ev-logo-loader.component";
import { UiService } from 'src/util/ui/ui.service';
import { environment } from 'src/environments/environment';


@Component({
    selector: 'unsubscribe',
    imports: [
        EvLogoLoaderComponent
    ],
    templateUrl: './unsubscribe.component.html',
    styleUrl: './unsubscribe.component.scss'
})
export class UnsubscribeComponent {
  private readonly unsubscribeService = inject(UnsubscribeService);
  private readonly route = inject(ActivatedRoute );
  private readonly uiService = inject(UiService);
  unsubscribeState: UnsubscribeState = UnsubscribeState.none;
  deleteMessage: string = "Er du helt sikker på at du ønsker å avslutte abonnementet?";
  key: string = "";
  showLoader: boolean = false;

  constructor() {
    this.uiService.stopGlobalSpinner();
    this.key = this.route.snapshot.queryParamMap.get('key');
  }

  unsubscribe(): void {
    this.showLoader = true;
    if (this.key) {
      this.unsubscribeService.postUnsubscribe(this.key).subscribe(x => {
        this.showLoader = false;
        this.setDeleteStatus(x);
      })
    } else {
      this.showLoader = false;
      this.setDeleteStatus();
    }
  }

  protected readonly IUnsubscribeState = UnsubscribeState;
  protected readonly support = environment.support;

  private setDeleteStatus(deleteStatus?: number): void {
    switch (deleteStatus) {
      case 0:
        this.unsubscribeState = UnsubscribeState.fail;
        this.deleteMessage = "Du er ikke mottaker av denne ukesrapporten.";
        break;
      case 1:
      case 2:
        this.unsubscribeState = UnsubscribeState.success;
        this.deleteMessage = "Abonnement avsluttet."
        break;
      default:
        this.unsubscribeState = UnsubscribeState.fail;
        this.deleteMessage = "Sletting av rapporten feilet.";
    }
  }
}

export enum UnsubscribeState {
  none,
  success,
  fail
}
